import styled from 'styled-components';

export const TooltipContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.neutrals.c800};
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
`;

export const KeyText = styled.span`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ theme }) => theme.colors.neutrals.white};
  font-size: ${({ theme }) => theme.fontVariants.desktop.buttons.sm.fontSize};
  line-height: ${({ theme }) => theme.fontVariants.desktop.buttons.sm.lineHeight};
  margin-bottom: 0.75rem;
`;

export const ValueKey = styled.span`
  color: ${({ theme }) => theme.colors.neutrals.c400};
  font-size: ${({ theme }) => theme.fontVariants.desktop.caption.md.fontSize};
  line-height: ${({ theme }) => theme.fontVariants.desktop.caption.md.lineHeight};
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const ValueText = styled.span`
  color: ${({ theme }) => theme.colors.neutrals.white};
  font-size: ${({ theme }) => theme.fontVariants.desktop.body.sm.fontSize};
  line-height: ${({ theme }) => theme.fontVariants.desktop.body.sm.lineHeight};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
